import { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Keyboard, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import './Gallery.css';

const IMAGES = [
  '/Images/pic1.png', '/Images/pic2.png', '/Images/pic3.png',
  '/Images/pic4.png', '/Images/pic5.png', '/Images/pic6.png',
  '/Images/pic7.png', '/Images/pic8.png', '/Images/pic9.jpg',
];

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);
  const swiperRef = useRef(null);

  return (
    <div className="galleryContainer">
      <button className="galNav galNav--prev" aria-label="Previous"
        onClick={() => swiperRef.current?.slidePrev()}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </button>

      <Swiper
        onSwiper={(s) => { swiperRef.current = s; }}
        modules={[EffectCoverflow, Keyboard, Autoplay]}
        effect="coverflow"
        grabCursor
        centeredSlides
        loop
        slidesPerView="auto"
        keyboard={{ enabled: true }}
        autoplay={{ delay: 3800, disableOnInteraction: false, pauseOnMouseEnter: true }}
        coverflowEffect={{ rotate: 0, stretch: 0, depth: 220, modifier: 1.7, slideShadows: false }}
        className="gallerySwiper"
      >
        {IMAGES.map((img, i) => (
          <SwiperSlide key={i} className="gallerySlide">
            <img src={img} alt={`Gallery ${i + 1}`} className="galleryImage" loading="lazy"
              onClick={() => setLightbox(img)} />
          </SwiperSlide>
        ))}
      </Swiper>

      <button className="galNav galNav--next" aria-label="Next"
        onClick={() => swiperRef.current?.slideNext()}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </button>

      {lightbox && (
        <div className="galLightbox" onClick={() => setLightbox(null)}>
          <img src={lightbox} alt="Expanded" />
        </div>
      )}
    </div>
  );
}
